import profile from '@/mixins/profile'
import reqCountry from '@/mixins/reqCountry'
import myAccess from '@/mixins/myAccess'
import currContractId from '@/mixins/currContractId'
import { SettlementsGQL } from '@/graphql/queries'

export const ShowOrderButton = {
  mixins: [profile, reqCountry, myAccess],

  computed: {
    ShowOrderButton () {
      return (
        this.profile.status === 'READY' &&
        this.profile.active &&
        (this.reqCountry.USA || (!this.profile.offline || this.profile.online)) &&
        this.myAccess.ORDER_LIST === 'WRITE'
      )
    }
  }
}

export const ShowOrdersChangeStatusControls = {
  mixins: [profile, reqCountry, myAccess],

  computed: {
    ShowOrdersChangeStatusControls () {
      return (
        this.profile.status === 'READY' &&
        this.profile.active &&
        this.myAccess.ORDER_LIST === 'WRITE'
      )
    }
  }
}

export const ShowAddManagerControl = {
  mixins: [myAccess, profile],

  computed: {
    ShowAddManagerControl () {
      return this.profile.status === 'READY' && this.myAccess.MANAGERS === 'WRITE'
    }
  }
}

export const ShowFpFieldQrCheck = {
  mixins: [reqCountry],

  computed: {
    ShowFpFieldQrCheck () {
      return !this.reqCountry.USA
    }
  }
}

export const ShowQrCheck = {
  mixins: [profile],

  computed: {
    ShowQrCheck () {
      return this.profile.isQrScan && this.profile.status !== 'DEACTIVATED'
    }
  }
}

export const ShowResponseQr = {
  mixins: [profile],

  computed: {
    ShowResponseQr () {
      return this.profile.isQrScan && this.profile.status !== 'DEACTIVATED'
    }
  }
}

export const ShowGoldShopLink = {
  mixins: [profile, reqCountry],

  computed: {
    ShowGoldShopLink () {
      return this.profile.programStatus === 'GOLD_SHOP' && this.profile.goldShopLogin
    }
  }
}

export const ShowRequireAction = {
  settlements: {
    query: SettlementsGQL,
    variables () {
      return {
        params: {
          partnerContractId: this.currContractId
        }
      }
    },
    update: data => data.merchant.settlements,
    skip () {
      return !this.currContractId
    }
  },

  mixins: [currContractId],

  computed: {
    ShowRequireAction () {
      return this.settlements && this.settlements.clientOrdersPendingCount > 0
    }
  }
}

export const ShowDashboardActions = {
  mixins: [ShowRequireAction, ShowGoldShopLink, ShowResponseQr, ShowQrCheck],

  computed: {
    ShowDashboardActions () {
      return this.ShowRequireAction || this.ShowGoldShopLink || this.ShowResponseQr || this.ShowQrCheck
    }
  }
}

export const ShowAddTerminal = {
  mixins: [profile],

  computed: {
    ShowAddTerminal () {
      return this.profile.status === 'NEW' || this.profile.status === 'CORRECTION'
    }
  }
}

export const ShowEditTerminalControl = {
  mixins: [profile],

  computed: {
    ShowEditTerminalControl () {
      return this.profile.status === 'NEW' || this.profile.status === 'CORRECTION'
    }
  }
}

export const ShowStores = {
  mixins: [profile],

  computed: {
    ShowStores () {
      return this.profile.offline
    }
  }
}

export const ShowRegisteredUsers = {
  mixins: [myAccess, profile, reqCountry],
  computed: {
    ShowRegisteredUsers () {
      return this.profile.programStatus === 'GOLD_SHOP' && (this.myAccess.USERS === 'READ' || this.myAccess.USERS === 'WRITE') && this.profile.status !== 'OUT_PLATFORM'
    }
  }
}

export const ShowAddUserControl = {
  mixins: [myAccess, profile, reqCountry],
  computed: {
    ShowAddUserControl () {
      return this.profile.programStatus === 'GOLD_SHOP' && this.myAccess.USERS === 'WRITE' && this.profile.status !== 'OUT_PLATFORM'
    }
  }
}

export const ShowTerminals = {
  mixins: [reqCountry],

  computed: {
    ShowTerminals () {
      return !this.reqCountry.USA
    }
  }
}

export const ShowGoldShopStatistics = {
  mixins: [reqCountry, myAccess],

  computed: {
    ShowGoldShopStatistics () {
      return this.profile.programStatus === 'GOLD_SHOP' && (this.myAccess.ORDER_LIST === 'READ' || this.myAccess.ORDER_LIST === 'WRITE')
    }
  }
}

export const ShowOrders = {
  mixins: [myAccess],

  computed: {
    ShowOrders () {
      return this.myAccess.ORDER_LIST === 'WRITE' || this.myAccess.ORDER_LIST === 'READ'
    }
  }
}

export const ShowBills = {
  mixins: [myAccess],

  computed: {
    ShowBills () {
      return this.myAccess.BILLS === 'WRITE' || this.myAccess.ORDER_LIST === 'READ'
    }
  }
}

export const ShowSettlements = {
  mixins: [profile, ShowBills],

  computed: {
    ShowSettlements () {
      return this.profile.prepayment && this.ShowBills
    }
  }
}

export const ShowPromoMaterials = {
  mixins: [profile],

  computed: {
    ShowPromoMaterials () {
      return this.profile.programStatus === 'GOLD_SHOP'
    }
  }
}

export const ShowManagersList = {
  mixins: [myAccess, profile],

  computed: {
    ShowManagersList () {
      return this.profile.status !== 'OUT_PLATFORM' && (this.myAccess.MANAGERS === 'WRITE' || this.myAccess.MANAGERS === 'READ')
    }
  }
}
